import { httpRequest } from "../../http";

export interface UpdateDefinitionPayload {
  name?: string;
  // Omit config for metadata edits — the backend leaves it untouched when absent.
  config?: any[];
  is_active?: boolean;
  population_segment_id?: number;
  population_segment_name?: string;
  organization?: { id: number; name: string };
  /*
      The primary data spec this one's files hang off (MPN-1564). Send null to
      unlink — the backend distinguishes "sent as null" from "not sent", so
      omitting the key leaves an existing link alone.
  */
  depends_on_id?: number | null;
  /* Hold a file that drops an unusual share of the population until Ops accepts or
     corrects it (MPN-2121). Primary files only. */
  hold_on_missing_members?: boolean;
}

export class CommandUpdateDefinition {
  async run(definitionId: number, payload: UpdateDefinitionPayload) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/${definitionId}/`;
    const response = await httpRequest<any>(url, {
      method: "PUT",
      body: payload,
    });
    return response;
  }
}
